<div class="assign-trips-container">
    <div *ngIf="loading" class="loading">
        <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
    </div>
    <div class="stepper-wrappper">
        <app-stepper></app-stepper>
    </div>
    <div class="add-subscriber-container">
        <div class="header">
            <div class="title">
                {{'buses.bulk-enroll.assign-trips-step.add-subscriber.title' |translate}}
            </div>
            <div class="sub-title">
                {{'buses.bulk-enroll.assign-trips-step.add-subscriber.sub-title' |translate}}
            </div>
        </div>
        <div class="metrics-wrapper">
            <div class="metric-card">
                <div class="title">
                    {{'buses.bulk-enroll.assign-trips-step.metrics.enrolled' |translate}}
                </div>
                <div class="number">
                    ({{enrolledCount | arabicNumber:currLang}})
                </div>
            </div>
            <div class="metric-card">
                <div class="title">
                    {{'buses.bulk-enroll.assign-trips-step.metrics.with-trips' |translate}}
                </div>
                <div class="number">
                    ({{withTripsCount | arabicNumber:currLang}})
                </div>
            </div>
            <div class="metric-card">
                <div class="title">
                    {{'buses.bulk-enroll.assign-trips-step.metrics.without-trips' |translate}}
                </div>
                <div class="number">
                    ({{withoutTripsCount | arabicNumber:currLang}})
                </div>
            </div>
        </div>
        <div class="add-subscriber-wrapper">
            <div class="subscriber-card">
                <div class="title">
                    {{'buses.bulk-enroll.assign-trips-step.add-subscriber.subscriber-title' |translate}}
                </div>
                <div class="header">
                    <input type="checkbox" [checked]="selectAll" (change)="toggleSelectAll()"
                        [disabled]="!selectedTrip" />
                    <input type="text" [placeholder]="'buses.bulk-enroll.assign-trips-step.search' | translate"
                        [value]="searchTerm" (input)="onSearchChange($event)" />
                    <!-- <select [value]="filterType" (change)="onFilterChange($event)">
                        <option value="all">
                            {{'buses.bulk-enroll.assign-trips-step.all' |translate}}
                        </option>
                        <option value="with_trips">
                            {{'buses.bulk-enroll.assign-trips-step.with-trips' |translate}}
                        </option>
                        <option value="without_trips">
                            {{'buses.bulk-enroll.assign-trips-step.without-trips' |translate}}
                        </option>
                    </select> -->

                    <div class="custom-select-wrapper">
                        <select class="custom-select" [value]="filterType" (change)="onFilterChange($event)">
                            <option value="all">
                                {{'buses.bulk-enroll.assign-trips-step.all' |translate}}
                            </option>
                            <option value="with_trips">
                                {{'buses.bulk-enroll.assign-trips-step.with-trips' |translate}}
                            </option>
                            <option value="without_trips">
                                {{'buses.bulk-enroll.assign-trips-step.without-trips' |translate}}
                            </option>
                        </select>
                        <svg class="custom-arrow" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                            viewBox="0 0 24 24" fill="none">
                            <path d="M6 9L12 15L18 9" stroke="#667085" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                </div>

                <div class="subscriber-list">
                    <div class="subscriber-item" *ngFor="let subscriber of filteredSubscribers"
                        [class.selected]="subscriber.trips.includes(selectedTrip?.trip_id)">
                        <label>
                            <input type="checkbox"
                                [(ngModel)]="subscriber.selected"
                                (change)="onSubscriberSelectionChange()"
                                [disabled]="!selectedTrip" />
                            <div class="subscriber-info">
                                <div class="name">{{ subscriber.name }}</div>
                                <div class="phone" data-pii="redact">{{ subscriber.national_id }}</div>
                                <!-- <div style="color: red;">{{ subscriber.id }}</div> -->


                                <div class="tag" *ngFor="let tripId of subscriber.trips; let i = index" [ngStyle]="{
                            'background-color': getTripStyle(subscriber, getTripById(tripId)?.name, i).bg,
                            'color': getTripStyle(subscriber, getTripById(tripId)?.name, i).text,
                            'border': '1px solid ' + getTripStyle(subscriber, getTripById(tripId)?.name, i).text}">
                                    {{ getTripById(tripId)?.name }}
                                    <span class="remove" (click)="removeTripTag(subscriber, tripId, $event)"
                                        [style.color]="getTripStyle(subscriber, getTripById(tripId)?.name, i).text">
                                        ×
                                    </span>
                                </div>

                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <div class="arrow" [ngStyle]="{'transform': currLang == 'en' ? 'rotate(0)' : 'rotate(180deg)'}">
                <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="0.5" width="44" height="44" rx="22" fill="#F1F6FA" />
                    <path d="M23.1667 16.5L29 22.5M29 22.5L23.1667 28.5M29 22.5L15 22.5" stroke="#0074EC"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </div>

            <!-- Available Trips Card -->
            <div class="available-trips-card">
                <div class="header">
                    <div class="title">
                        {{'buses.bulk-enroll.assign-trips-step.available-trips' |translate}}
                    </div>
                    <button class="clear-all-btn" (click)="clearAllAssignments()">
                        {{'buses.bulk-enroll.assign-trips-step.clear-all' |translate}}
                    </button>
                </div>
                <div class="custom-dropdown" [class.open]="dropdownOpen">
                    <div class="dropdown-header" (click)="dropdownOpen = !dropdownOpen">
                        <span *ngIf="!selectedTrip">
                            {{'buses.bulk-enroll.assign-trips-step.select-trip' |translate}}
                        </span>
                        <span *ngIf="selectedTrip">{{ selectedTrip.name }}</span>
                        <span class="dropdown-arrow">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none">
                                <path d="M6 9L12 15L18 9" stroke="#667085" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </span>
                    </div>
                    <div class="dropdown-list" *ngIf="dropdownOpen">
                        <div class="trip-type-toggle-inside">
                            <button [class.active]="selectedTripType === 'morning'"
                                (click)="toggleTripType('morning'); $event.stopPropagation();">
                                <span>
                                    {{'buses.bulk-enroll.assign-trips-step.go-trips' |translate}}
                                </span>
                            </button>
                            <button [class.active]="selectedTripType === 'afternoon'"
                                (click)="toggleTripType('afternoon'); $event.stopPropagation();">
                                <span>
                                    {{'buses.bulk-enroll.assign-trips-step.back-trips' |translate}}
                                </span>
                            </button>
                        </div>
                        <div class="dropdown-trip-list">
                            <div class="dropdown-trip-item" *ngFor="let trip of filteredTrips"
                                (click)="selectTrip(trip); dropdownOpen = false">
                                <div class="trip-name">{{ trip?.name }}</div>
                                <div class="bus-number">{{ trip?.trip_id }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedTrip" class="selected-trip-details">
                    <div class="trip-header">
                        <span class="area-name">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none">
                                <path
                                    d="M7.99991 14.4001C7.99991 14.4001 13.0086 9.94792 13.0086 6.60879C13.0086 3.84257 10.7661 1.6001 7.99991 1.6001C5.23368 1.6001 2.99121 3.84257 2.99121 6.60879C2.99121 9.94792 7.99991 14.4001 7.99991 14.4001Z"
                                    stroke="#667085" />
                                <path
                                    d="M9.60011 6.4002C9.60011 7.28385 8.88377 8.0002 8.00011 8.0002C7.11646 8.0002 6.40011 7.28385 6.40011 6.4002C6.40011 5.51654 7.11646 4.8002 8.00011 4.8002C8.88377 4.8002 9.60011 5.51654 9.60011 6.4002Z"
                                    stroke="#667085" />
                            </svg>
                            {{ selectedTrip.area_name }}</span>
                        <span class="bus-name">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none">
                                <path
                                    d="M15.2048 5.40161C14.728 4.46561 13.7568 3.82241 12.6368 3.82241H1.75998C1.05438 3.82241 0.47998 4.39681 0.47998 5.10241V10.5408C0.47998 11.2464 1.05438 11.8208 1.75998 11.8208H2.65278C2.80158 12.5696 3.46398 13.136 4.25598 13.136C5.04798 13.136 5.70878 12.5696 5.85918 11.8208H10.144C10.2928 12.5696 10.9552 13.136 11.7472 13.136C12.5392 13.136 13.2 12.5696 13.3504 11.8208H14.24C14.9456 11.8208 15.52 11.2464 15.52 10.5408V6.70721C15.52 6.26881 15.4192 5.85441 15.2432 5.48161C15.2336 5.45441 15.2208 5.42721 15.2048 5.40161ZM12.928 5.90401H14.728C14.824 6.15361 14.88 6.42401 14.88 6.70881V7.82561H12.928V5.90401ZM4.25438 12.496C3.70558 12.496 3.26078 12.0496 3.26078 11.5024C3.26078 10.9536 3.70718 10.5088 4.25438 10.5088C4.80318 10.5088 5.24958 10.9552 5.24958 11.504C5.24958 12.0496 4.80318 12.496 4.25438 12.496ZM11.7456 12.496C11.1968 12.496 10.7504 12.0496 10.7504 11.5008C10.7504 10.952 11.1968 10.5056 11.7456 10.5056C12.2944 10.5056 12.7392 10.952 12.7408 11.4992C12.7392 12.0512 12.2928 12.496 11.7456 12.496ZM14.24 11.1824H13.3472C13.1984 10.4336 12.536 9.86721 11.744 9.86721C10.952 9.86721 10.2912 10.4336 10.1408 11.1824H5.85758C5.70878 10.4336 5.04638 9.86721 4.25438 9.86721C3.46238 9.86721 2.80158 10.4336 2.65118 11.1824H1.75998C1.40638 11.1824 1.11998 10.896 1.11998 10.5424V5.10401C1.11998 4.75041 1.40638 4.46401 1.75998 4.46401H12.6352C13.3232 4.46401 13.9376 4.77601 14.3504 5.26401H2.23998C2.06398 5.26401 1.91998 5.40801 1.91998 5.58401V8.14561C1.91998 8.32161 2.06398 8.46561 2.23998 8.46561H14.88V9.50401H14.0992C13.9232 9.50401 13.7792 9.64801 13.7792 9.82401C13.7792 10 13.9232 10.144 14.0992 10.144H14.88V10.5424C14.88 10.8944 14.5936 11.1824 14.24 11.1824ZM10.336 5.90401H12.288V7.82561H10.336V5.90401ZM7.74398 5.90401H9.69598V7.82561H7.74398V5.90401ZM5.15198 5.90401H7.10398V7.82561H5.15198V5.90401ZM2.55998 7.82561V5.90401H4.51198V7.82561H2.55998ZM10.2128 3.50401C10.3888 3.50401 10.5328 3.36001 10.5328 3.18401C10.5328 3.00801 10.3888 2.86401 10.2128 2.86401H4.18238C4.00638 2.86401 3.86238 3.00801 3.86238 3.18401C3.86238 3.36001 4.00638 3.50401 4.18238 3.50401H10.2128Z"
                                    fill="#667085" />
                            </svg>
                            {{ selectedTrip.bus_name }}
                        </span>
                    </div>
                    <div class="assigned-subscribers-list">
                        <div class="title" *ngIf="getAssignedSubscribers(selectedTrip.trip_id)?.length > 0">
                            {{'buses.bulk-enroll.assign-trips-step.assigned-subscribers' |translate}}
                        </div>
                        <div class="assigned-subscriber"
                            *ngFor="let sub of getAssignedSubscribers(selectedTrip.trip_id)">
                            <div class="subscriber-info">
                                <span class="subscriber-name">{{ sub.name }}</span>
                                <span class="subscriber-phone" data-pii="redact">{{ sub.national_id }}</span>
                                <!-- <span style="color: green;">{{ sub?.id }}</span> -->
                            </div>
                            <span class="delete-icon" (click)="removeSubscriberFromTrip(sub, selectedTrip)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M10 11V17M14 11V17"
                                        stroke="#667085" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </span>
                        </div>
                    </div>
                </div>
                
                <!-- Empty State when no trip is selected -->
                <div *ngIf="!selectedTrip" class="empty-state">
                    <div class="empty-state-title">{{'buses.bulk-enroll.assign-trips-step.empty-state.title' |translate}}</div>
                    <div class="empty-state-description">{{'buses.bulk-enroll.assign-trips-step.empty-state.description' |translate}}</div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="save-btn-container">
    <button class="save-btn" (click)="save()">
        {{'buses.bulk-enroll.assign-trips-step.save-btn' |translate}}
    </button>
</div>

<!-- Confirmation Modal -->
<div class="assign-trips-modal-backdrop" *ngIf="showConfirmModal">
    <div class="assign-trips-modal">
        <button class="close-btn" (click)="closeModal()">&times;</button>
        <div class="title">{{'buses.bulk-enroll.assign-trips-step.modals.confirmation.title' |translate}}</div>
        <div class="hint">{{'buses.bulk-enroll.assign-trips-step.modals.confirmation.hint' |translate}}</div>
        <div class="modal-actions">
            <button class="skip-btn"
                (click)="skipStep()">{{'buses.bulk-enroll.assign-trips-step.modals.confirmation.skip-btn'
                |translate}}</button>
            <button class="assign-btn"
                (click)="assignTripsNow()">{{'buses.bulk-enroll.assign-trips-step.modals.confirmation.assign-btn'
                |translate}}</button>
        </div>
    </div>
</div>

<!-- Navigation Away Modal -->
<div class="assign-trips-modal-backdrop" *ngIf="showNavigationModal">
    <div class="assign-trips-modal">
        <div class="title">{{'buses.bulk-enroll.assign-trips-step.modals.navigation.title' |translate}}</div>
        <div class="hint">{{'buses.bulk-enroll.assign-trips-step.modals.navigation.hint' |translate}}</div>
        <div class="modal-actions">
            <button class="skip-btn"
                (click)="leavePage()">{{'buses.bulk-enroll.assign-trips-step.modals.navigation.leave-btn'
                |translate}}</button>
            <button class="assign-btn"
                (click)="save()">{{'buses.bulk-enroll.assign-trips-step.modals.navigation.save-btn'
                |translate}}</button>
        </div>
    </div>
</div>